import { useMemo } from 'react';

import { useAISmartButtonActions } from '../../ai-smart-button-store';

/**
 * Hook for managing surface-level actions and configurations.
 */
export const useSurfaceAIActions = () => {
	const { setSelectors, setSurfaceMetadata } = useAISmartButtonActions();

	return useMemo(
		() => ({
			/**
			 * Sets selectors for filtering actions, suggested actions, and nudges.
			 */
			setSelectors,
			/**
			 * Sets metadata about the surface where AI features are used.
			 */
			setSurfaceMetadata,
		}),
		[setSelectors, setSurfaceMetadata],
	);
};

export type SurfaceAIActions = ReturnType<typeof useSurfaceAIActions>;
